import configureStore from 'configureStore';
import { storeRegistry } from './storeRegistry';

const store = configureStore();
storeRegistry['store'] = store;

export default store;
